import {useI18n} from 'i18n/I18nContext'
import React, {useState} from 'react'
import {useEditor} from 'TemplateEditor/EditorProvider'
import styled from 'styled-components'
import TuneIcon from '@mui/icons-material/Tune'
import {TemplateGlobalPaddingPanel} from 'TemplateEditor/Layout/Sidebar/TemplateGlobalPaddingPanel'

export function TemplateGlobalSettings() {
  const {t} = useI18n()
  const {editMode} = useEditor()
  const [open, setOpen] = useState(false)

  if (!editMode) return null

  return (
    <Wrap>
      <ToggleButton
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <TuneIcon style={{fontSize: 16}} />
        {t('templateEditor.defaultValuesButton')}
      </ToggleButton>
      {open && (
        <PanelScroll>
          <TemplateGlobalPaddingPanel />
        </PanelScroll>
      )}
    </Wrap>
  )
}

const Wrap = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
`

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 5px 12px;
  min-height: 30px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.92);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 6px;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.22);
  }
`

const PanelScroll = styled.div`
  margin-top: 10px;
  max-height: min(48vh, 380px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px 8px 4px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-sizing: border-box;
`
